<template>
  <div>
    <!-- ccb393 -->
    <div class="row">
      <div class="col-6">
        <h2 class="no-margin pb-3">Invoice Statements</h2>
      </div>
      <div class="col-6 text-right">
        <button
          type="button"
          v-on:click="redirect_pay_invoice"
          class="button-green-small px-5"
        >
          Pay Bill
        </button>
      </div>
    </div>

    <div
      class="row"
      style="background: #f0f1f1; padding-top: 1em; border-radius: 5px"
    >
      <div class="col-large-3 pb-3">
        <select v-model="selected_month" v-on:change="validate_month">
          <option value="">Select month</option>
          <option value="all">All</option>
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
          <option value="6">June</option>
          <option value="7">July</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
        <small class="error-message" v-if="month_error">
          This field is required
        </small>
      </div>
      <div class="col-large-3 pb-3">
        <select v-model="selected_year" v-on:change="validate_year">
          <option value="">Select year</option>
          <option
            v-for="year in years_dropdown_list"
            v-bind:key="year"
            :value="year"
          >
            {{ year }}
          </option>
        </select>
        <small class="error-message" v-if="year_error">
          This field is required
        </small>
      </div>
      <div
        class="col-large-6 pb-3 text-center text-large-right align-self-center"
      >
        <small
          v-if="loading_PDF"
          class="mr-3"
          style="
            font-weight: 700;
            color: #17355c;
            font-size: 14px;
            font-style: italic;
          "
        >
          <img src="/images/loading.png" alt="Loading" style="width: 15px" />
          {{ loading_PDF_message }}
        </small>
        <small v-if="error_pdf" class="mr-3 error-message">
          {{ error_pdf_message }}
        </small>
        <button
          :class="
            disable_PDF_button ? 'button-gray-small' : 'button-green-small'
          "
          :disabled="disable_PDF_button ? true : false"
          v-on:click="generate_PDF"
        >
          Download PDF
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    
    mounted() {
      this.fill_years();
    },
    data: function () {
      return {
        selected_month: '',
        month_error: false,
        selected_year: '',
        year_error: false,
        disable_PDF_button: true,
        loading_PDF: false,
        loading_PDF_message: 'INVOICE(S) LOADING...',
        error_pdf: false,
        error_pdf_message:
          'Error generating PDF. Please contact Customer Care.',
        years_dropdown_list: [],
      };
    },
    methods: {
      fill_years() {
        const now = new Date();
        let year = now.getFullYear();

        for (let i = year; i >= 2017; i--) {
          this.years_dropdown_list.push(i);
        }
      },
      generate_PDF() {
        this.error_pdf = false;
        this.error_pdf_message =
          'Error generating PDF. Please contact Customer Care.';

        if (this.validate_page()) {
          this.loading_PDF = true;
          this.disable_PDF_button = false;
          this.loading_PDF_message = 'INVOICE(S) LOADING...';
          if (this.selected_month === 'all') {
            this.loading_PDF_message =
              'INVOICE(S) LOADING...MAY TAKE UP TO 5 SECONDS';
          }

          axios
            .get(
              '/authnet/fetch-invoice-pdf/' +
                this.selected_month +
                '/' +
                this.selected_year
            )
            .then((success) => {
              if (success.data.success) {
                const link = document.createElement('a');
                link.href = location.origin + '/' + success.data.pdf;
                link.setAttribute('download', success.data.file_name); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                this.error_pdf = true;
                this.error_pdf_message = success.data.message;
              }

              this.loading_PDF = false;
            })
            .catch((error) => {
              this.error_pdf = true;
              this.loading_PDF = false;
            });
        }
      },
      validate_page() {
        var month_response = this.validate_month();
        var year_response = this.validate_year();
        return month_response && year_response;
      },
      validate_month() {
        this.error_pdf = false;
        this.month_error = false;

        if (!this.selected_month) {
          this.month_error = true;
        }

        if (this.selected_month && this.selected_year) {
          this.disable_PDF_button = false;
        } else {
          this.disable_PDF_button = true;
        }

        return !this.month_error;
      },
      validate_year() {
        this.error_pdf = false;
        this.year_error = false;

        if (!this.selected_year) {
          this.year_error = true;
        }

        if (this.selected_month && this.selected_year) {
          this.disable_PDF_button = false;
        } else {
          this.disable_PDF_button = true;
        }

        return !this.year_error;
      },
      redirect_pay_invoice() {
        window.location = '/dashboard/pay-invoice';
      },
    },
  };
</script>
